module.exports = __webpack_public_path__ + "static/media/poo-storm.66ee6c98.svg";